import { ArrowLeft, Clock, Download } from "lucide-react";

const PASSI = [
  {
    t: "0:00 — Prima di entrare",
    d: "Apri sul tuo telefono la pagina della prova. Non parlare del gestionale: chiedi com'è andato il servizio ieri sera.",
    dire: "«Ieri sera quante comande hai perso o sbagliato?»",
  },
  {
    t: "0:30 — Fai il questionario davanti a lui",
    d: "Tipo di attività, zone, quante persone in squadra. Lascialo rispondere lui: sono 6 domande, un minuto.",
    dire: "«Rispondi tu, così esce il tuo locale e non un esempio.»",
  },
  {
    t: "1:30 — Mostra il locale già pronto",
    d: "Apri Sala: tavoli e zone ci sono. Apri Menu: i piatti della sua cucina ci sono. Nessuna configurazione.",
    dire: "«Questo l'ha creato lui in un minuto, non l'ho preparato io.»",
  },
  {
    t: "2:30 — La comanda che arriva in cucina",
    d: "Apri un tavolo, aggiungi due piatti, invia. Passa al Monitor cucina: la comanda è là, con i tempi che partono.",
    dire: "«Da qui la cucina sa cosa fare e da quanto aspetta. Niente urla, niente foglietti.»",
  },
  {
    t: "3:30 — Segna pronto e chiudi il conto",
    d: "Dal monitor segna un piatto pronto, torna in sala, chiudi il conto e dividi tra due persone.",
    dire: "«Il conto è già fatto: dividi, incassi, e a fine serata la cassa quadra da sola.»",
  },
  {
    t: "4:30 — Lascialo provare, poi fermati",
    d: "Dagli il telefono per due comande. Non mostrare magazzino e statistiche: sono la seconda visita.",
    dire: "«Provalo stasera con il tuo servizio. Domani mi dici cosa non ti torna.»",
  },
];

const OBIEZIONI = [
  ["«Quanto costa?»", "In beta è gratis, nessuna carta. Se poi ti serve, ne parliamo con i numeri in mano."],
  ["«E se non funziona internet?»", "Le comande già aperte restano leggibili e si sincronizzano quando la linea torna."],
  ["«Il mio personale non è capace.»", "Il cameriere vede solo tavoli e comande. Il PIN glielo dai tu e in dieci minuti va."],
  ["«Ho già il registratore di cassa.»", "Questo non lo sostituisce: gli evita di riscrivere tutto a mano."],
  ["«E i miei dati?»", "Sono solo tuoi, li puoi scaricare quando vuoi e chiedere la cancellazione in qualsiasi momento."],
];

export default function GuidaDemo() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="guida-demo-page">
      <style>{`@media print {
        .no-print { display:none !important; }
        @page { size:A4; margin:14mm; }
        body { font-size:10pt; }
        .sheet { box-shadow:none !important; padding:0 !important; }
      }`}</style>

      <div className="no-print border-b border-slate-200 bg-slate-950 px-6 py-5 text-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4">
          <a href="/biglietto" className="text-xs font-semibold text-slate-400 hover:text-amber-400" data-testid="guida-back">
            <ArrowLeft className="mr-1 inline h-3 w-3" /> Biglietto della prova
          </a>
          <a
            href={`${process.env.REACT_APP_BACKEND_URL}/api/public/kit/guida.pdf`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex h-11 items-center rounded-md bg-amber-500 px-5 font-bold text-slate-950 transition-colors hover:bg-amber-400"
            data-testid="guida-pdf-btn"
          >
            <Download className="mr-2 h-4 w-4" /> Apri il PDF
          </a>
        </div>
      </div>

      <div className="sheet mx-auto max-w-3xl px-6 py-10">
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-amber-600">Reprehendo · foglio da tasca</p>
        <h1 className="font-head mt-2 text-3xl font-bold sm:text-4xl">Cinque minuti a casa del cliente</h1>
        <p className="mt-2 text-sm text-slate-600">
          L'ordine dei passaggi da fare davanti a lui. Non serve altro: telefono, questa pagina e un biglietto da lasciare.
        </p>

        <div className="mt-8 space-y-4">
          {PASSI.map((p) => (
            <div key={p.t} className="border-l-2 border-amber-400 pl-4">
              <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.12em] text-slate-500">
                <Clock className="h-3 w-3" /> {p.t}
              </p>
              <p className="mt-1 text-sm text-slate-800">{p.d}</p>
              <p className="mt-1 text-sm font-semibold italic text-amber-700">{p.dire}</p>
            </div>
          ))}
        </div>

        <h2 className="font-head mt-10 text-lg font-bold md:text-lg">Se ti dice…</h2>
        <div className="mt-3 space-y-2">
          {OBIEZIONI.map(([q, a]) => (
            <div key={q} className="rounded-md border border-slate-200 p-3">
              <p className="text-sm font-bold text-slate-900">{q}</p>
              <p className="mt-0.5 text-sm text-slate-700">{a}</p>
            </div>
          ))}
        </div>

        <h2 className="font-head mt-10 text-lg font-bold md:text-lg">Da ricordare</h2>
        <ul className="mt-3 space-y-1.5 text-sm text-slate-700">
          <li>· La prova dura <strong>7 giorni con tutte le funzioni</strong>. Alla scadenza non si blocca: continua in versione base.</li>
          <li>· I PIN del personale li crea <strong>il titolare</strong> da Dipendenti: il sistema li genera e lui li detta.</li>
          <li>· Tavoli, squadra e magazzino vanno poi messi sui suoi numeri veri: il questionario dà la base, non i suoi dati.</li>
          <li>· Se merita più tempo, <strong>dalla Console gli regali 12 mesi Pro</strong> e gli arriva l'email del regalo.</li>
          <li>· Lascia sempre un biglietto: lui riprova da solo la sera, quando ha calma.</li>
        </ul>

        <p className="mt-10 border-t border-slate-200 pt-4 text-xs text-slate-500">
          Reprehendo · reprehendo.viglietron.com · gratis durante la beta, nessuna carta di credito
        </p>
      </div>
    </div>
  );
}
